import { ProLayoutProps } from '@ant-design/pro-components';
// import { Settings as LayoutSettings} from '@ant-design/pro-layout/defaultSettings'
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#2c2f57',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '衣者供应链管理系统',
  pwa: false,
  logo: 'https://dafeiimg.huole.cn/yizhe/icon/logo.png',
  iconfontUrl: '',
  menu: {
    locale: false,
    defaultOpenAll: false,
    ignoreFlatMenu: false,
  },
  siderWidth: 216,
  token: {
    // bgLayout: "red",
    sider: {
      colorMenuBackground: '#2c2f57',
      // colorBg
      // colorBgCollapsedButton: '#fff',
      // colorTextCollapsedButtonHover: 'rgba(0,0,0,0.65)',
      // colorTextCollapsedButton: 'rgba(0,0,0,0.45)',
      // colorMenuBackground: '#004FD9',
      // colorBgMenuItemCollapsedElevated: 'rgba(0,0,0,0.85)',
      // colorMenuItemDivider: 'rgba(255,255,255,0.15)',
      colorBgMenuItemHover: '#2a336f',
      colorBgMenuItemSelected: '#2150f5',
      colorTextMenuSelected: '#fff',
      colorTextMenuItemHover: '#fff',
      colorTextMenu: '#fff',
      // colorTextMenuSecondary: 'rgba(255,255,255,0.65)',
      // colorTextMenuTitle: 'rgba(255,255,255,0.95)',
      // colorTextMenuActive: 'rgba(255,255,255,0.95)',
      // colorTextSubMenuSelected: '#fff',
    },
    // bgLayout: 'rgba(237, 242, 250, 1)',
    header: {
      //   colorBgHeader: "#2c2f57",
    },
    pageContainer: {
      paddingInlinePageContainerContent: 24,
    },
  },
};

export default Settings;
